import { render, staticRenderFns } from "./popViewCard.vue?vue&type=template&id=165307b0"
import script from "./popViewCard.vue?vue&type=script&lang=js"
export * from "./popViewCard.vue?vue&type=script&lang=js"
import style0 from "./popViewCard.vue?vue&type=style&index=0&id=165307b0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports